/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DeliveryAddressModel from './DeliveryAddressModel';

/**
* The DeliveryAddressCreateResultModel model module.
* @module model/DeliveryAddressCreateResultModel
* @version 1.0.0
*/
export default class DeliveryAddressCreateResultModel {
    /**
    * Constructs a new <code>DeliveryAddressCreateResultModel</code>.
    * @alias module:model/DeliveryAddressCreateResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>DeliveryAddressCreateResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DeliveryAddressCreateResultModel} obj Optional instance to populate.
    * @return {module:model/DeliveryAddressCreateResultModel} The populated <code>DeliveryAddressCreateResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DeliveryAddressCreateResultModel();
                        
            
            if (data.hasOwnProperty('DeliveryAddress')) {
                obj['DeliveryAddress'] = DeliveryAddressModel.constructFromObject(data['DeliveryAddress']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/DeliveryAddressModel} DeliveryAddress
    */
    'DeliveryAddress' = undefined;




}
